export enum Axios {
    DELETE = 'DELETE',
    PUT = 'PUT',
    POST = 'POST',
}